import {
    Component,
    ChangeDetectionStrategy,
    Input,
    Output,
    EventEmitter,
} from '@angular/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'vsf-product-list-pagination',
    templateUrl: './product-list-pagination.component.html',
    styleUrls: ['./product-list-pagination.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductListPaginationComponent {
    @Input() totalResults$: Observable<number>;
    @Input() currentPage$: Observable<number>;
    @Input() totalPages$: Observable<number>;
    @Input() perPage$: Observable<number>;
    @Input() canGoPrevious$: Observable<boolean>;
    @Input() canGoNext$: Observable<boolean>;
    @Input() pageNumbers$: Observable<number[]>;

    @Output() goToFirst = new EventEmitter<void>();
    @Output() goToPrevious = new EventEmitter<void>();
    @Output() goToNext = new EventEmitter<void>();
    @Output() goToLast = new EventEmitter<void>();
    @Output() goToPage = new EventEmitter<number>();
    @Output() perPageChange = new EventEmitter<number>();
}
